import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlControleRestitutionResponse extends IIsiDtoPresentationLogicResponse  {
    message?: string;
    hasError?: boolean;
    getAllListLigneDemResult?: string[];
    getAnnulerEnlevementResult?: IIsiDtoRemovalTreatment;
    getRemettreEnlevementResult?: IIsiDtoRemovalTreatment;
    getRestoreResult?: IIsiServerToClientBusinessObject;
}
export interface IIsiDtoRemovalTreatment extends IIsiDataTransferObject  {
    fromResumeRemoval?: boolean;
    toEnterQty?: number;
    scanQty?: number;
    popinDisplay?: boolean;
    resultError?: boolean;
    resultMessage?: string;
}
export class IsiDtoRemovalTreatment extends IsiDataTransferObject implements IIsiDtoRemovalTreatment {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.PurchaseCycle.IsiDtoRemovalTreatment, Isilog.IsiComponent.IsiDataTransferObject";
    fromResumeRemoval?: boolean;
    toEnterQty?: number;
    scanQty?: number;
    popinDisplay?: boolean;
    resultError?: boolean;
    resultMessage?: string;

    constructor(data?: IIsiDtoRemovalTreatment) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fromResumeRemoval = _data["fromResumeRemoval"] !== undefined ? _data["fromResumeRemoval"] : false;
            this.toEnterQty = _data["toEnterQty"] !== undefined ? _data["toEnterQty"] : 0;
            this.scanQty = _data["scanQty"] !== undefined ? _data["scanQty"] : 0;
            this.popinDisplay = _data["popinDisplay"] !== undefined ? _data["popinDisplay"] : false;
            this.resultError = _data["resultError"] !== undefined ? _data["resultError"] : false;
            this.resultMessage = _data["resultMessage"] !== undefined ? _data["resultMessage"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoRemovalTreatment): IsiDtoRemovalTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoRemovalTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["fromResumeRemoval"] = this.fromResumeRemoval !== undefined ? this.fromResumeRemoval : false;
        data["toEnterQty"] = this.toEnterQty !== undefined ? this.toEnterQty : 0;
        data["scanQty"] = this.scanQty !== undefined ? this.scanQty : 0;
        data["popinDisplay"] = this.popinDisplay !== undefined ? this.popinDisplay : false;
        data["resultError"] = this.resultError !== undefined ? this.resultError : false;
        data["resultMessage"] = this.resultMessage !== undefined ? this.resultMessage : <any>null;
        return data;
    }
}
export interface IIsiServerToClientBusinessObject {
}
export class IsiDtoPlControleRestitutionResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlControleRestitutionResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Dto.UI.PresentationLogic.ControleRestitution.IsiDtoPlControleRestitutionResponse, Isilog.IsiComponent.IsiDataTransferObject";
    message?: string;
    hasError?: boolean;
    getAllListLigneDemResult?: string[];
    getAnnulerEnlevementResult?: IsiDtoRemovalTreatment;
    getRemettreEnlevementResult?: IsiDtoRemovalTreatment;
    getRestoreResult?: IIsiServerToClientBusinessObject;

    constructor(data?: IIsiDtoPlControleRestitutionResponse) {
        super(data);
        if (data) {
            this.getAnnulerEnlevementResult = data.getAnnulerEnlevementResult && !(<any>data.getAnnulerEnlevementResult).toJSON ? new IsiDtoRemovalTreatment(data.getAnnulerEnlevementResult) : <IsiDtoRemovalTreatment>this.getAnnulerEnlevementResult;
            this.getRemettreEnlevementResult = data.getRemettreEnlevementResult && !(<any>data.getRemettreEnlevementResult).toJSON ? new IsiDtoRemovalTreatment(data.getRemettreEnlevementResult) : <IsiDtoRemovalTreatment>this.getRemettreEnlevementResult;
            this.getRestoreResult = data.getRestoreResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.hasError = _data["hasError"] !== undefined ? _data["hasError"] : false;
            this.getAllListLigneDemResult = _data["getAllListLigneDemResult"];
            this.getAnnulerEnlevementResult = _data["getAnnulerEnlevementResult"] ? IsiDtoRemovalTreatment.fromJS(_data["getAnnulerEnlevementResult"]) : <any>null;
            this.getRemettreEnlevementResult = _data["getRemettreEnlevementResult"] ? IsiDtoRemovalTreatment.fromJS(_data["getRemettreEnlevementResult"]) : <any>null;
            this.getRestoreResult = _data["getRestoreResult"];
        }
    }

    static fromJS(data?: IIsiDtoPlControleRestitutionResponse): IsiDtoPlControleRestitutionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlControleRestitutionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["hasError"] = this.hasError !== undefined ? this.hasError : false;
        data["getAllListLigneDemResult"] = this.getAllListLigneDemResult !== undefined ? this.getAllListLigneDemResult : [];
        data["getAnnulerEnlevementResult"] = this.getAnnulerEnlevementResult != null ? (<any>this.getAnnulerEnlevementResult).toJSON() : <any>null;
        data["getRemettreEnlevementResult"] = this.getRemettreEnlevementResult != null ? (<any>this.getRemettreEnlevementResult).toJSON() : <any>null;
        data["getRestoreResult"] = this.getRestoreResult != null ? (<any>this.getRestoreResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlControleRestitutionRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlControleRestitutionResponse;
    columnKey?: string;
    associatedViewContextId?: string;
    checkTreatment?: CheckTreatmentType;
    answerPopin?: boolean;
    checkPopin?: boolean;
    qteSaisieScan?: number;
    values?: IIsiDtoSelectedRecord[];
}
export enum CheckTreatmentType {
    None = 0,
    VerifAvancement = 1,
    VerifAvancementLigneDem = 2,
    VerifAvancementAndStatutReception = 3,
}
export interface IIsiDtoSelectedRecord extends IIsiDataTransferObject  {
    fields?: IIsiDtoSelectedFieldValue[];
}
export interface IIsiDtoSelectedFieldValue extends IIsiDataTransferObject  {
    value?: string;
    key?: string;
}
export class IsiDtoSelectedFieldValue extends IsiDataTransferObject implements IIsiDtoSelectedFieldValue {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedFieldValue, Isilog.IsiComponent.IsiDataTransferObject";
    value?: string;
    key?: string;

    constructor(data?: IIsiDtoSelectedFieldValue) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoSelectedFieldValue): IsiDtoSelectedFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
export class IsiDtoSelectedRecord extends IsiDataTransferObject implements IIsiDtoSelectedRecord {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Mark.IsiDtoSelectedRecord, Isilog.IsiComponent.IsiDataTransferObject";
    fields?: IsiDtoSelectedFieldValue[];

    constructor(data?: IIsiDtoSelectedRecord) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fields = _data["fields"] !== undefined ? _data["fields"] : [];
        }
    }

    static fromJS(data?: IIsiDtoSelectedRecord): IsiDtoSelectedRecord {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSelectedRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["fields"] = this.fields !== undefined ? this.fields : [];
        return data;
    }
}
export class IsiDtoPlControleRestitutionRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlControleRestitutionRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Dto.UI.PresentationLogic.ControleRestitution.IsiDtoPlControleRestitutionRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlControleRestitutionResponse;
    columnKey?: string;
    associatedViewContextId?: string;
    checkTreatment?: CheckTreatmentType;
    answerPopin?: boolean;
    checkPopin?: boolean;
    qteSaisieScan?: number;
    values?: IsiDtoSelectedRecord[];

    constructor(data?: IIsiDtoPlControleRestitutionRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlControleRestitutionResponse(data.response) : <IsiDtoPlControleRestitutionResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlControleRestitutionResponse.fromJS(_data["response"]) : <any>null;
            this.columnKey = _data["columnKey"] !== undefined ? _data["columnKey"] : <any>null;
            this.associatedViewContextId = _data["associatedViewContextId"] !== undefined ? _data["associatedViewContextId"] : <any>null;
            this.checkTreatment = _data["checkTreatment"] !== undefined ? _data["checkTreatment"] : CheckTreatmentType.None;
            this.answerPopin = _data["answerPopin"] !== undefined ? _data["answerPopin"] : null;
            this.checkPopin = _data["checkPopin"] !== undefined ? _data["checkPopin"] : null;
            this.qteSaisieScan = _data["qteSaisieScan"] !== undefined ? _data["qteSaisieScan"] : null;
            this.values = _data["values"] !== undefined ? _data["values"] : [];
        }
    }

    static fromJS(data?: IIsiDtoPlControleRestitutionRequest): IsiDtoPlControleRestitutionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlControleRestitutionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["columnKey"] = this.columnKey !== undefined ? this.columnKey : <any>null;
        data["associatedViewContextId"] = this.associatedViewContextId !== undefined ? this.associatedViewContextId : <any>null;
        data["checkTreatment"] = this.checkTreatment !== undefined ? this.checkTreatment : CheckTreatmentType.None;
        data["answerPopin"] = this.answerPopin !== undefined ? this.answerPopin : null;
        data["checkPopin"] = this.checkPopin !== undefined ? this.checkPopin : null;
        data["qteSaisieScan"] = this.qteSaisieScan !== undefined ? this.qteSaisieScan : null;
        data["values"] = this.values !== undefined ? this.values : [];
        return data;
    }
}
